<div class="mb-2">
  <fgb-errors></fgb-errors>
</div>
<div class="d-flex justify-content-start align-items-center">
  <button (click)="loginSportsAlliance()" class="btn btn-primary btn-block fw-bold w-100">Login</button>
</div>
